module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQ4je2V4Q2CMBCFn8b/MgIj4AaMwAiOoBs4gm6AGziCG8gIuAEbPPNMSwgebQjgL17StM31vjbXy92GJAwlADLLYKh241eC90ZKsuE4FQYHO+O+I4C9W98ANIFXn9xZzY++0YJ7nQFcIyER8DVk3AYcqwg4eqb7coUjBZB39vmAX1/yu7gQlm0oSSYkq5EfGJKSIftmIclyRrBXLbjy3Ez0GXQIfehUJUvCg6m4wlf4n+H3BbhvAE/feVQL5ixcua8tukk9s3Clc4pUatVAagD4AHX7epaGt4H1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/logo/paquete-ic.png
// module id = 206
// module chunks = 0